// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".woocommerce-notices-wrapper .woocommerce-message .fa{position:absolute;top:5px;right:10px;cursor:pointer}@media only screen and (max-width:768px){#notice{position:absolute;top:50%;transform:translateY(-50%)}}", ""]);
// Exports
module.exports = exports;
